import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';

export default TimelineOppositeContent;
